/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface DidDetail
 */
export interface DidDetail {
  /**
   *
   * @type {string}
   * @memberof DidDetail
   */
  areaCode?: string;
  /**
   *
   * @type {string}
   * @memberof DidDetail
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof DidDetail
   */
  display?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof DidDetail
   */
  flags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof DidDetail
   */
  id?: string;
  /**
   *
   * @type {boolean}
   * @memberof DidDetail
   */
  isTollfree?: boolean;
  /**
   *
   * @type {string}
   * @memberof DidDetail
   */
  label?: string;
  /**
   *
   * @type {boolean}
   * @memberof DidDetail
   */
  labelEdited?: boolean;
  /**
   *
   * @type {string}
   * @memberof DidDetail
   */
  number?: string;
}

/**
 * Check if a given object implements the DidDetail interface.
 */
export function instanceOfDidDetail(value: object): value is DidDetail {
  return true;
}

export function DidDetailFromJSON(json: any): DidDetail {
  return DidDetailFromJSONTyped(json, false);
}

export function DidDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DidDetail {
  if (json == null) {
    return json;
  }
  return {
    areaCode: json['area_code'] == null ? undefined : json['area_code'],
    country: json['country'] == null ? undefined : json['country'],
    display: json['display'] == null ? undefined : json['display'],
    flags: json['flags'] == null ? undefined : json['flags'],
    id: json['id'] == null ? undefined : json['id'],
    isTollfree: json['is_tollfree'] == null ? undefined : json['is_tollfree'],
    label: json['label'] == null ? undefined : json['label'],
    labelEdited:
      json['label_edited'] == null ? undefined : json['label_edited'],
    number: json['number'] == null ? undefined : json['number'],
  };
}

export function DidDetailToJSON(value?: DidDetail | null): any {
  if (value == null) {
    return value;
  }
  return {
    area_code: value['areaCode'],
    country: value['country'],
    display: value['display'],
    flags: value['flags'],
    id: value['id'],
    is_tollfree: value['isTollfree'],
    label: value['label'],
    label_edited: value['labelEdited'],
    number: value['number'],
  };
}
